<template>
    <ModalBox v-model="show">
        <div class="ai-model">
            <div class="title">模型展示 {{category}}</div>
            <div class="body">
                <div class="model" v-for="item in modelList" :key="item.value">
                    <div class="model-content" @click="setModel(item)">
                        <div class="model-title">
                            {{ item.title }}
                            <div class="classification">{{ item.category }}</div>
                            <div class="setting" @click.stop="showModelSetting(item)">
                                <i class="ecp-iconfont ecp-icon-setting"></i>参数设置
                            </div>
                        </div>
                        <p class="description">
                            {{ item.description }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </ModalBox>
</template>

<script>
import { cloneDeep } from 'lodash';
import MODEL_LIST from '@/app/constant/MODEL_LIST.js';
import ModalBox from '../ui/ModalBox.vue';
export default {
    name: 'gpt-dialog-ai-model',
    components: { ModalBox },
    data () {
        let show = false;
        let modelList = null;
        return { show, modelList };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        category: {
            type: String,
            default: ''
        }
    },
    mounted () {
        this.show = this.visible;
        this.modelList = MODEL_LIST;
    },
    watch: {
        visible (val) {
            this.show = val;
        },
        show (val) {
            this.$emit('update:visible', val);
        },
        category (val) {
            if (val) {
                this.modelList = MODEL_LIST.filter(item => item.category === val);
            } else {
                this.modelList = MODEL_LIST;
            }
        }
    },
    methods: {
        open () {
            this.show = true;
        },
        setModel (item) {
            this.$bus.$emit('setModelData', item);
            this.show = false;
        },
        showModelSetting (item) {
            this.$emit('showModelSetting', item);
        }
    }
};
</script>

<style scoped lang="scss">
::v-deep{
    .frame{
        padding-right: 0px;
}
}
.ai-model {
    width: 1000px;
    height: 536px;

    .title {
        color: var(--font-color);
        height: 24px;
        font-size: 16px;
        font-weight: 500;
        font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
        line-height: 24px;
        margin-bottom: 6px;
    }

    .el-icon-circle-close {
        position: absolute;
        font-size: 22px;
        top: 0;
        right: -30px;
        opacity: 0.45;
        color: var(--font-color);
        cursor: pointer;
    }

    .body {
        padding-left: 8px;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        height: calc(100% - 24px);
        .model {
            width: 312px;
            height: 152px;
            background-image: var(--ai-model-card);
            background-repeat: no-repeat;
            background-size: cover;
            box-shadow: 0px 2px 6px 0px rgba(7,22,51,0.2);
            border-radius: 8px;
            box-sizing: border-box;
            margin: 6px 16px 10px 0;
            cursor: pointer;
            .model-content{
                width: 100%;
                height: 100%;
                padding: 16px 24px 24px 24px;
                background: var(--msg-welcome-prompt-bg);
                background: none;
                border-radius: 8px;
                position: relative;
                box-sizing: border-box;
                border: 1px solid transparent;
                &:hover {
                    border: 1px solid var(--ai-model-classification-font);
                    .model-title .setting{
                        display: block;
                    }
                }
            }
            &:nth-child(3n){
                margin: 6px 0 10px 0;
            }

            .model-title {
                height: 24px;
                font-size: 16px;
                font-weight: 500;
                font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
                color: var(--font-color);
                line-height: 24px;
                display: flex;
                align-items: center;
                position: relative;

                .classification {
                    color: var(--ai-model-classification-font);
                    background: var(--ai-model-classification-bg);
                    border-radius: 2px;
                    display: inline-block;
                    font-size: 10px;
                    font-weight: 500;
                    font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
                    line-height: 18px;
                    width: 60px;
                    height: 18px;
                    text-align: center;
                    margin-left: 8px;
                    padding: 0 4px;
                }
                .setting {
                    position: absolute;
                    font-size: 14px;
                    right: 0;
                    display: none;
                    color: var(--ai-model-classification-font);
                    cursor: pointer;
                    i {
                        padding-right: 4px;
                    }
            }
            }

            .description {
                font-size: 14px;
                color: var(--ai-description-text);
                line-height: 20px;
                margin-top: 8px;
            }
        }
    }
}
</style>
